import {
  replaceStringWithNlInsideQuotes,
  textileRegLink,
  textInsidePreTagsReg,
} from 'helpers/constants/reg'

export const replaceAllLinks = (value) => {
  return value.replaceAll(textileRegLink, (fragment, before, link, end) => {
    //В js регексе нельзя сделать *SKIP, поэтому выбираем текст внутри <pre и скипаем так
    if (textInsidePreTagsReg.test(fragment)) {
      return fragment
    }
    if (before !== undefined) {
      return fragment
    }
    if (end === undefined) {
      end = ''
    }

    return `"${link}":${link}${end}`
  })
}

export const preparedCode = (value) => {
  return value.replaceAll('<code>\n', '<code>')
}
/**
 * Замена ковычек с кейсом где
 * внутри двойных ковычек перенос строки + символ сразу после закрывающей без пробела + что-то похожее на ссылку после через пробел
 * @param value
 * @returns {string}
 */
export const replaceQuotedStringsWithNl = (value) => {
  return value.replaceAll(
    replaceStringWithNlInsideQuotes,
    (fragment, item, item2) => {
      if (item && item2) {
        return fragment.replace('"', '«').replace('"', '»')
      }
      if (item) {
        return fragment.replaceAll('"', "'")
      }

      return fragment
    }
  )
}
